import { useNavigate } from "react-router-dom";
import CreditNoticePng from "../../assets/images/creditNotice.png";
import { ReactComponent as SearchNotFound } from "../../assets/images/searchResultsNotFound.svg";
import { useState } from "react";
import { useEffect } from "react";
import { useMemo } from "react";
import { Select } from "./Select";

export const CreditNotice = ({
  leftButton,
  rightButton,
  onclick,
  des2,
  title,
  des,
  NoCredits,
  company_id,
  handlePurchased,
  profileViews,
  userInfo,
  selectedEnterprise,
  setSelectedEnterprise,
  userEnterprise,
  handleNavigation = false
}) => {
  const [selectedCredit, setSelectedCredit] = useState("");

  useEffect(() => {
      setSelectedCredit('credit')
  }, [userEnterprise])

  const navigate = useNavigate();
  const handleNavigateToPlan = () => {
    if (handleNavigation) {
      handlePurchased("pay")
    } else {
      window.scrollTo(0, 0);
      navigate("/plans", {
        state: {
          company_id: company_id,
        },
      });
    }
  };

  const handleSelectedEnterprise = (event) => {
    const value = event.target.value;
    if (value !== "") {
      setSelectedEnterprise(value)
    }
  }

  const contentHTML = { __html: des };
  const content2HTML = { __html: des2 };

  const handleNavigateToBilling = () => {
    navigate("/dashboard/billing");
  };
  return (
    <div className="mx-auto py-10 relative pb-2">
      <div className="w-full flex justify-center items-center py-2">
        <SearchNotFound />
      </div>
      {(!userEnterprise || userEnterprise?.length === 0) && <><h2 className="text-f20 font-extrabold">{title}</h2>
        <p
          className="text-secondary pt-2 pb-4 w-96 text-f14"
          dangerouslySetInnerHTML={contentHTML}
        /></>}
      {userEnterprise?.length > 0 && <><div className={`w-[${NoCredits ? "auto" : "600px"}] flex gap-2`}>
        <div onClick={() => { setSelectedEnterprise(""); setSelectedCredit("credit") }} className={`bg-[#FAFAFA] w-full flex gap-3 ${selectedCredit === "credit" ? "border-[#002940]  border-2" : !NoCredits && "border"} py-5 px-6 rounded-[8px] border text-[#012234] cursor-pointer hover:border-[#002940] hover:border-2}`}>
          <input type="radio" name={"credit"} value={"credit"} checked={selectedCredit === "credit"} onChange={() => { setSelectedCredit("credit") }} className="cursor-pointer" />
          <div className="text-left">
            <p className="text-f18 font-semibold">My Subscription</p>
            <p className="text-secondary text-f14 w-[250px]">{des}</p>
          </div>
        </div>
        {/* <div onClick={userEnterprise?.length > 0 ? */}
      </div>
        {selectedCredit === "enterprise" && <div className="pt-5">
          <Select
            label="Select Business (For Using Enterprise credit)"
            id="enterpriseList"
            value={selectedEnterprise}
            placeholder="Select a Enterprise"
            onChange={handleSelectedEnterprise}
          >
            {userEnterprise?.map((enterprise) => (
              <option key={enterprise?.id} value={enterprise}>
                {enterprise?.name + ` (${enterprise.enterprise_type === "PARTNER_PROGRAM" ? "Unlimited" : enterprise?.credits} Credit Remaining)`}
              </option>
            ))}
          </Select>
        </div>}</>}
      <br />
      <div className="flex gap-5">
        {/* <button onClick={NoCredits ? */}
        <button
          disabled={!selectedCredit || (selectedCredit === 'enterprise' && !selectedEnterprise)}
          onClick={(NoCredits && selectedCredit === "credit") ? handleNavigateToPlan : ((selectedCredit === "credit" && !NoCredits) || (selectedCredit === "enterprise" && selectedEnterprise)) ? () => handlePurchased(selectedCredit === 'enterprise' ? 'enterprise' : 'credit') : handleNavigateToPlan}
          className={`w-full px-2 py-3 text-white text-f14 font-semibold rounded w-full ${(selectedCredit && !(selectedCredit === 'enterprise' && !selectedEnterprise)) ? "bg-primary cursor-pointer" : "bg-disable cursor-not-allowed"}`}
        >
          {selectedCredit === "credit" && NoCredits ? "Buy Credit And Proceed" : rightButton}
        </button>
      </div>
    </div>
  );
};
